import { render } from "./TransparentBtn.vue?vue&type=template&id=cbc29b68&scoped=true"
import script from "./TransparentBtn.vue?vue&type=script&lang=js"
export * from "./TransparentBtn.vue?vue&type=script&lang=js"

import "./TransparentBtn.vue?vue&type=style&index=0&id=cbc29b68&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc29b68"]])

export default __exports__